import React, { useState, useEffect } from 'react';
import { RiSearchLine } from 'react-icons/ri';
import { IoMdClose } from 'react-icons/io';

import { injectIntl } from '../../util/reactIntl';

import css from './BrowseFreelancersPage.css';

const BrowseFreelancersSearchBarComponent = props => {
  const { onSetKeywords, initialKeywords, clearSearchBar, intl } = props;
  const [searchTerm, setSearchTerm] = useState(initialKeywords || '');

  // Update search term when initialKeywords changes
  useEffect(() => {
    setSearchTerm(initialKeywords || '');
  }, [initialKeywords]);

  // Clear search bar when clearSearchBar prop changes
  useEffect(() => {
    if (clearSearchBar) {
      setSearchTerm('');
    }
  }, [clearSearchBar]);

  const handleInputChange = e => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      onSetKeywords(searchTerm);
    }
  };

  const handleSearch = () => {
    onSetKeywords(searchTerm);
  };

  const inputPlaceholderText = intl.formatMessage({
    id: 'BrowseFreelancersSearchBar.placeholder',
  });

  return (
    <div className={css.searchBar}>
      <div className={css.inputContainer}>
        <RiSearchLine className={css.searchIcon} />
        <input
          type="text"
          placeholder={inputPlaceholderText}
          value={searchTerm}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />

        <div className={css.searchRightMobileContainer}>
          {searchTerm && (
            <div
              className={css.clearSearchBar}
              onClick={() => {
                setSearchTerm('');
                onSetKeywords('');
              }}
            >
              <IoMdClose className={css.clearIcon} />
            </div>
          )}
          <div className={css.searchIconMobileContainer} onClick={handleSearch}>
            <RiSearchLine className={css.searchIconMobile} />
          </div>
        </div>
      </div>
    </div>
  );
};

const BrowseFreelancersSearchBar = injectIntl(BrowseFreelancersSearchBarComponent);

export default BrowseFreelancersSearchBar;
